// @flow
/**
 * Helpers for remote soft-lock presentation on participant cards.
 */

export type PresenceUser = {
  userId: number,
  firstName?: string,
  lastName?: string,
};

export function getParticipantUserId(
  participant: ?Object,
  participantId: ?string | number
): ?number {
  if (participant) {
    if (
      participant.user &&
      typeof participant.user === 'object' &&
      participant.user.id != null
    ) {
      return Number(participant.user.id);
    }
    if (participant.userId != null) {
      return Number(participant.userId);
    }
    if (participant.user != null && typeof participant.user !== 'object') {
      return Number(participant.user);
    }
  }
  if (participantId != null && String(participantId).includes('_')) {
    const n = parseInt(String(participantId).split('_')[0], 10);
    return Number.isNaN(n) ? null : n;
  }
  return null;
}

export function getRemoteLockHolderUserId(
  participantUserId: ?number,
  locksByParticipantUserId: ?Object,
  currentUserId: ?number
): ?number {
  if (participantUserId == null || !locksByParticipantUserId) return null;
  const holder = locksByParticipantUserId[String(participantUserId)];
  if (holder == null) return null;
  if (currentUserId != null && Number(holder) === Number(currentUserId)) {
    return null;
  }
  return Number(holder);
}

export function formatLockHolderName(
  holderUserId: ?number,
  presenceUsers: ?Array<PresenceUser>
): string {
  if (holderUserId == null) return 'another admin';
  const list = presenceUsers || [];
  const u = list.find((p) => Number(p.userId) === Number(holderUserId));
  if (!u) return 'another admin';
  const name = [u.firstName, u.lastName].filter(Boolean).join(' ').trim();
  return name || 'another admin';
}

export function lockTooltipTitle(holderName: string): string {
  return `Being edited by ${holderName} — you cannot move this participant right now`;
}
